module.exports = __webpack_public_path__ + "assets/img/deadline.6147fb4f.png";